export const masterAddData = (state) => state.reports.summary.masterAdditionalData;
export const reportType = (state) => state.reports.summary.reportType;
export const reportAdditionalData = (state) => state.reports.summary.reportAdditionalData;
export const selectedReport = (state) => state.reports.summary.selectedReport || {};
